export default {
    resetImportParcels(state) {
      state.importParcels = [];
    },
    setImportParcels(state, payload) {   
      state.importParcels = payload;
    },    
    setLogistics(state, payload) {
      state.logistics = payload;
    },
    setBoxTypes(state, payload) {
      state.boxTypes = payload;
    },
    setUnits(state, payload) {
      state.units = payload;
    },
    setCustomers(state, payload) {
      state.customers = payload;
    },    
    setBarcodes(state, payload) {
      state.barcodes = payload;
    },    
    setLotParcel(state, payload) {
      state.lotParcel = payload;
    },
    
  };
  